import { Form } from "react-bootstrap";
import "./LabelAndTextBox.css"
import React, { useState, useEffect } from "react";

interface LabelAndTextProps {
    title: string;
    remark?: string | number | null;
    onChange: (value: string) => void;
    disabled?: boolean;
    placeholder?: string;
}

const LabelAndTextBox = ({ remark, title, onChange, disabled, placeholder }: LabelAndTextProps) => {
    const [text, setText] = useState(remark?.toString() || '');

    // Update internal state when remark changes
    useEffect(() => {
        setText(remark?.toString() || '');
    }, [remark]);

    return (
        <Form.Group className={disabled ? "disabled" : ""}>
            <Form.Label className="fw-bold fs-6 mt-2">{title + ":"}</Form.Label>
            <Form.Control
                className="textbox"
                type="text"
                value={text}
                placeholder={placeholder}
                onChange={(event) => {
                    setText(event.target.value);
                    onChange(event.target.value);
                }}
                disabled={disabled}
            />
        </Form.Group>
    );
};

export default LabelAndTextBox;
